import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/attendance.js (mounted at /api/attendance),
// the WORKER/teacher attendance table (SGE_ATTENDANCE) — distinct from
// /api/student-attendance (services/studentAttendance.js) used by Presenças de
// Estudantes. GET fills any date with no record as a virtual ABSENT entry.
export async function getAttendanceReport({ workerId, startDate, endDate, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/attendance/${id}`, { params: { workerId, startDate, endDate } });
}

export async function registerFirstEntrance({ workerId, workerName, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/attendance/first-entrance`, {
    workerId,
    workerName,
    sucursalId: id,
    registeredByAdmin: true,
  });
}

export async function registerOtherEntrance({ workerId, workerName, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/attendance/other-entrance`, {
    workerId,
    workerName,
    sucursalId: id,
    registeredByAdmin: true,
  });
}

export async function registerExit(attendanceId, { sucursalId } = {}) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.put(`${baseURL}api/attendance/exit/${attendanceId}`, { sucursalId: id, registeredByAdmin: true });
}

export async function registerJustification({ id, workerId, workerName, date, sucursalId, justification, justificationType }) {
  const sid = sucursalId || getSucursalInfo()?.id || 1;
  if (id) {
    return API.post(`${baseURL}api/attendance/justification/register/${id}`, { justification, justificationType });
  }
  return API.post(`${baseURL}api/attendance/justification/register/none`, {
    workerId,
    workerName,
    date,
    sucursalId: sid,
    justification,
    justificationType,
  });
}

// POST /attendance/report/global — generates the printable PDF covering every
// collaborator for the period (mirrors sge_infantil_web's "Imprimir Relatório"
// button on the admin Presenças screen). Backend uploads it to S3 and returns
// { fileUrl }.
export async function printAttendanceReport({ startDate, endDate, selectedYear, selectedMonth, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/attendance/report/global`, {
    startDate,
    endDate,
    sucursalId: id,
    selectedYear,
    selectedMonth,
  });
}

// POST /attendance/report/individual — same PDF, scoped to a single
// collaborator (mirrors sge_infantil_web's per-row "Imprimir" action on the
// admin Presenças screen). Backend uploads it to S3 and returns { fileUrl }.
export async function printIndividualAttendanceReport({ workerId, startDate, endDate, selectedYear, selectedMonth, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/attendance/report/individual`, {
    workerId,
    startDate,
    endDate,
    sucursalId: id,
    selectedYear,
    selectedMonth,
  });
}
